import React from 'react'
import { createContext, useContext, useEffect, useState } from 'react'
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../firebase';
import {
  collection,
  getDocs,
  getDoc,
  deleteDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db, DB } from "../firebase";
import { getAuth, signInWithPopup, GoogleAuthProvider, OAuthProvider, getAdditionalUserInfo } from "firebase/auth";



export const UserContext = createContext();

export function AuthContextProvider({ children }) {
  const [user, setUser] = useState(null);

  function signIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password)
    //console.log(signInWithEmailAndPassword(auth, email, password))
  }

  function logout() {
    return signOut(auth)
  }

  async function cancelSignUp(userObj) {
    const userInfo = getAdditionalUserInfo(userObj);
    if (userInfo?.isNewUser) {
      const user = userObj.user;
      await logout();
      await user.delete();
      localStorage.removeItem('token');
      return true;
    } else {
      return false;
    }
  }

  function googleSignIn() {
    const provider = new GoogleAuthProvider();
    const _auth = getAuth();
    return signInWithPopup(_auth, provider)
    // .then((result) => {
    //   // This gives you a Google Access Token. You can use it to access the Google API.
    //   const credential = GoogleAuthProvider.credentialFromResult(result);
    //   const token = credential.accessToken;
    //   // The signed-in user info.
    //   const user = result.user;
    //   // IdP data available using getAdditionalUserInfo(result)
    //   // ...
    // }).catch((error) => {
    //   // Handle Errors here.
    //   const errorCode = error.code;
    //   const errorMessage = error.message;
    //   // The email of the user's account used.
    //   const email = error.customData.email;
    //   // The AuthCredential type that was used.
    //   const credential = GoogleAuthProvider.credentialFromError(error);
    //   // ...
    // });
  }

  function appleSignIn() {
    const provider = new OAuthProvider('apple.com')
    const _auth = getAuth();
    return signInWithPopup(_auth, provider)

  }
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser !== null) {
        localStorage.setItem('token', currentUser.accessToken);
        //console.log( localStorage.getItem('token'));
        const docRef = doc(DB, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);

        const docRef2 = doc(DB, "subscriptionplans", docSnap.data().plan);
        const docSnap2 = await getDoc(docRef2);

        //   if (docSnap.exists()) {
        //     console.log("Document data:", docSnap.data());
        //   } else {
        //     // docSnap.data() will be undefined in this case
        //     console.log("No such document!");
        // }

        let usr = { ...currentUser, metadata: docSnap.data(), subscription: docSnap2.data() }
        setUser(usr);
        // console.log('***')
        // const docRef = doc(db, "users", currentUser.uid);
        // const docSnap = await getDoc(docRef);
        // console.log('doc: ', docSnap)
        //console.log(usr)
      }
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, logout, signIn, googleSignIn, appleSignIn, cancelSignUp }}>
      {children}
    </UserContext.Provider>
  );
};

export function UserAuth() {
  return useContext(UserContext);
};